var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * default
 */
var Zoomable = /** @class */ (function () {
    function Zoomable(dom, options) {
        var _this = this;
        this._isZooming = false;
        this._disabled = false;
        this.handleMouseWheel = function (event) {
            if (_this._options.preventDefault) {
                event.original.preventDefault();
            }
            var x = event.x, y = event.y, normalizeWheel = event.normalizeWheel;
            var delta = -normalizeWheel.spinY;
            var _a = _this._options.sensitivity, sensitivity = _a === void 0 ? 1 : _a;
            var scale = delta > 0 ? delta / (30 / sensitivity) + 1 : 1 / (1 - delta / (30 / sensitivity));
            if (_this._options.onZooming) {
                _this._options.onZooming({
                    delta: delta,
                    mouse: event,
                    origin: [x, y],
                    zoom: scale,
                    position: [0, 0],
                });
            }
        };
        this.handleTouchStart = function (event) {
            var touches = event.touches;
            if (touches.length >= 2) {
                if (_this._isZooming) {
                    return;
                }
                if (_this._options.onZoomStart) {
                    _this._options.onZoomStart();
                }
                _this._isZooming = true;
                _this._startTouchs = touches.slice(0, 2);
            }
        };
        this.handleTouchMove = function (event) {
            var touches = event.touches;
            if (!_this._isZooming || touches.length < 2) {
                return;
            }
            if (event.original.preventDefault) {
                event.original.preventDefault();
            }
            var startTouchs = _this._startTouchs;
            var ids = startTouchs.map(function (touch) { return touch.identifier; });
            var currentTouches = touches.filter(function (touch) { return ids.indexOf(touch.identifier) !== -1; });
            var startLen = _this.getTouchesDistance(startTouchs);
            var currentLen = _this.getTouchesDistance(currentTouches);
            var scale = currentLen / startLen;
            _this._startTouchs = currentTouches;
            var origin1 = _this.getOrigin(startTouchs);
            var origin2 = _this.getOrigin(currentTouches);
            if (_this._options.onZooming) {
                _this._options.onZooming({
                    origin: origin1,
                    zoom: scale,
                    position: [origin2[0] - origin1[0], origin2[1] - origin1[1]],
                });
            }
        };
        this.handleTouchEnd = function (event) {
            var touches = event.touches;
            if (!_this._isZooming) {
                return;
            }
            var startTouchs = _this._startTouchs;
            var ids = startTouchs.map(function (touch) { return touch.identifier; });
            var currentTouches = touches.filter(function (touch) { return ids.indexOf(touch.identifier) !== -1; });
            if (currentTouches.length !== 2) {
                _this._isZooming = false;
                if (_this._options.onZoomEnd) {
                    _this._options.onZoomEnd();
                }
            }
        };
        this._dom = dom;
        this._options = __assign({ preventDefault: true }, options);
        this.initZoomEvents();
    }
    Zoomable.prototype.initZoomEvents = function () {
        var dom = this._dom;
        dom.on('touchstart', this.handleTouchStart);
        dom.on('touchmove', this.handleTouchMove);
        dom.on('touchend', this.handleTouchEnd);
        dom.on('touchcancel', this.handleTouchEnd);
        dom.on('wheel', this.handleMouseWheel);
    };
    Zoomable.prototype.disable = function () {
        this.destroy();
    };
    Zoomable.prototype.enable = function () {
        if (this._disabled) {
            this.initZoomEvents();
        }
    };
    Zoomable.prototype.getTouchVector = function (touches) {
        var x1 = touches[0].x;
        var y1 = touches[0].y;
        var x2 = touches[1].x;
        var y2 = touches[1].y;
        return [x2 - x1, y2 - y1];
    };
    Zoomable.prototype.getTouchesDistance = function (touches) {
        var x1 = touches[0].x;
        var y1 = touches[0].y;
        var x2 = touches[1].x;
        var y2 = touches[1].y;
        return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    };
    Zoomable.prototype.getOrigin = function (touches) {
        var x = (touches[0].x + touches[1].x) / 2;
        var y = (touches[0].y + touches[1].y) / 2;
        return [x, y];
    };
    Zoomable.prototype.destroy = function () {
        var dom = this._dom;
        dom.off('touchstart', this.handleTouchStart);
        dom.off('touchmove', this.handleTouchMove);
        dom.off('touchend', this.handleTouchEnd);
        dom.off('touchcancel', this.handleTouchEnd);
        dom.off('wheel', this.handleMouseWheel);
        this._isZooming = false;
        this._disabled = true;
    };
    return Zoomable;
}());
export default Zoomable;
